
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ED2939","d":"M0 0h900v600H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 0h600v600H0z"}}),_c('path',{attrs:{"fill":"#002395","d":"M0 0h300v600H0z"}})])
          )
        }
      }
    